var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injector, OnInit } from '@angular/core';
import { ContactBaseComponent } from './../common-theme/index';
import { OpenModalService } from '../common-theme/base-components/shared/modals/open-modal.service';
import { AgencyService } from '../common-theme/api/agency.service';
var ContactComponent = /** @class */ (function (_super) {
    __extends(ContactComponent, _super);
    function ContactComponent(injector, agencyService, window, document, openModalService) {
        var _this = _super.call(this, injector, agencyService, window) || this;
        _this.document = document;
        _this.openModalService = openModalService;
        return _this;
    }
    ContactComponent.prototype.openMessageModal = function () {
        this.openModalService.showContactFormModal();
        if (this.document)
            this.document.body.classList.add('no-scroll');
    };
    ContactComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.setTitle('Contacteaza echipa proiectului rezidential Dream Residence');
        this.setMetaDescription("Contacteaza-ne. Dream Residence s-a nascut din dorinta de a face ceva diferit si din a crea un acasa perfect pentru fiecare rezident. Intra in legatura cu noi.");
    };
    return ContactComponent;
}(ContactBaseComponent));
export { ContactComponent };



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts.pre-build-optimizer.js